export interface Taggable {
	id: number;
	getTagName(data?: {}): string;
}
